import { render, staticRenderFns } from "./SuppliersTable.vue?vue&type=template&id=063c967e&scoped=true&"
import script from "./SuppliersTable.vue?vue&type=script&lang=js&"
export * from "./SuppliersTable.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersTable.vue?vue&type=style&index=0&id=063c967e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c967e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VPagination,VProgressLinear})
